import { useQuery } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";

interface UseQueryOptions {
  enabled?: boolean;
}

export const useContactDeals = (
  contactUuid: string,
  options: UseQueryOptions = {},
) => {
  return useQuery({
    queryKey: dealQueryKeys.byContact(contactUuid),
    queryFn: () => dealApi.getDealsByContact(contactUuid),
    enabled: (options.enabled ?? true) && !!contactUuid,
  });
};
